import styled from "@emotion/styled";
import { Grid } from "@mui/material"; 
import React from "react";
// import { P, SectionSubHeading } from "../../../styles";

const SectionSubHeading = styled.h3`
  font: 40px "two-cent-Bold";
  text-transform: uppercase;
  color: ${(props) => (props.color ? props.color : "#ffffff")};
  margin: ${(props) => (props.m ? props.m : "auto")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "750px")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin-bottom: 10px;
  @media (max-width: 899px) {
    font-size: 40px;
  }
  @media (max-width: 599px) {
    font-size: 35px;
  }
`;
const P = styled.p`
  font-size: 18px;
  display: list-item;
  list-style-position: inside;
  list-style-type: style type circle;;
  font-family: "two-cent-regular";
  color: ${(props) => (props.color ? props.color : "#000000")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin-top: ${(props) => (props.mt ? props.mt : "20px")};
  margin-bottom: ${(props) => (props.mb ? props.mb : "20px")};
  margin-left: ${(props) => (props.ml ? props.ml : "0px")};
  margin-right: ${(props) => (props.mr ? props.mr : "0px")};

  @media (max-width: 899px) {
    font-size: 14px;
  }
`;

const RoadmapCardStyle = styled(Grid)`
  padding: 55px 30px 00px;
  margin: auto;
  > div {
    > div {
      position: absolute;
      top: -40px;
      left: 0;
      right: 0;
      text-align: center;
      @media (max-width: 899px) {
        right: -10%;
        left: unset;
      }
    }
  }
  &:nth-child(3) {
    > div {
      > div {
        right: unset;
        left: -8%;
        @media (max-width: 599px) {
          left: -10%;
        }
      }
    }
  }
  &:nth-child(5) {
    > div {
      > div {
        right: -8%;
        left: unset;
        @media (max-width: 899px) {
          left: 0;
          right: 0;
        }
        @media (max-width: 599px) {
          left: -10%;
          right: unset;
        }
      }
    }
  }

  @media (max-width: 1200px) {
    padding: 10px 10px 50px;
  }
`;
const RoadmapCardInner = styled.div`
  padding: 35px 15px;
  min-height: ${(props) => (props.min ? props.min : "0px")};
  background-color: ${(props) => (props.bg ? props.bg : "#ffffff")};
  color: #000;
  position: relative;
  max-width: 380px;
  @media (max-width: 1200px) {
    padding: 10px 10px;
  }
  @media (max-width: 899px) {
    max-width: 100%;
  }
  &:nth-child(1) {
    /* padding-top: 50px; */
    margin-bottom: 20px;
  }
`;

const RoadmapCards = (props) => {
  return (
    <RoadmapCardStyle xs={12} sm={6} md={4}>
      <SectionSubHeading>{props.cardNumber}</SectionSubHeading>
      <RoadmapCardInner bg={props.bg} min="290px">
        <P color={props.color}>{props.cardDiscription1}</P>
        <P color={props.color}>{props.cardDiscription2}</P>
        <P color={props.color}>{props.cardDiscription3}</P>
        <P color={props.color}>{props.cardDiscription4}</P>
      </RoadmapCardInner>
    </RoadmapCardStyle>
  );
};

export default RoadmapCards;
